const defaultState = {
  orderChan: null,
  orderStatus: null,
  orderType: null,
  payWay: null,
  receiveWay: null,
  aftersaleType: null,
  aftersaleReason: null,
  status: [
    { name: '未审核', code: 0 },
    { name: '已审核', code: 1 },
    { name: '已驳回', code: 2 },
  ],
  //缴款类型
  payTypes: null,
}

function orderReducer(state = defaultState, action) {
  switch (action.type) {
    case 'order/getParams':
      let payload = action.payload || {}
      return {
        ...state,
        ...payload,
      }
    default:
      return state
  }
}
export default orderReducer
